import type { SxProps, Theme } from '@mui/material/styles';

export const mergeSx = (
  ...values: Array<SxProps<Theme> | false | null | undefined>
): SxProps<Theme> | undefined => {
  const merged = values.flatMap(value => {
    if (!value) {
      return [];
    }

    return Array.isArray(value) ? value.filter(Boolean) : [value];
  });

  return merged.length > 0 ? merged : undefined;
};
